import {http, onSuccess, onFail} from "./http";

export const getClientFields = () =>
    http.get(`/api/cp/client/field`)
        .then(onSuccess, onFail);

export const createClientField = (data) =>
    http.post(`/api/cp/client/field`, data)
        .then(onSuccess, onFail);

export const updateClientField = (fieldId, data) =>
    http.put(`/api/cp/client/field/${fieldId}`, data)
        .then(onSuccess, onFail);

export const deleteClientField = (fieldId) =>
    http.delete(`/api/cp/client/field/${fieldId}`)
        .then(onSuccess, onFail);